import { render, staticRenderFns } from "./EgiftCard.vue?vue&type=template&id=ee8ac5ee&scoped=true"
import script from "./EgiftCard.vue?vue&type=script&lang=js"
export * from "./EgiftCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee8ac5ee",
  null
  
)

export default component.exports